import { Component, Input } from '@angular/core';
import { DataService } from 'src/app/shared/services/data.service';
@Component({
  selector: 'app-my-grades',
  templateUrl: './my-grades.component.html',
  styleUrls: ['./my-grades.component.scss']
})
export class MyGradesComponent {
  constructor(private dataService: DataService){}
  generalSettingsData:any;
  @Input() averages: any = [];
  @Input() noGradesMessage: string = '';
  ngOnInit(): void {
    this.dataService.updateGeneralSettingsData$.subscribe((value) => {
      this.generalSettingsData=value;
    })
   }
}
